import React from "react";
import { SSCIAM_ACCESS_TOKEN_KEY } from "../authHelper";
import { AuthLabel } from "./AuthLabel";

export const SsciamAuthLabel = () => {
  return <AuthLabel tokenKey={SSCIAM_ACCESS_TOKEN_KEY} label="New login" colorClass="ssciam" />;
};
